module.exports = ".flex-container{display:flex;justify-content:left;flex-wrap:wrap}\n"